import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { Assessment } from './Assessment';
import { useAssessmentPage } from './hooks';
import { theme } from '@store';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import logo from '@assets/logo_light_bg.svg';

export const AssessmentPage = () => {
  const {
    assessment,
    assessment_id,
    token,
    loading,
    isConfirmed,
    handleConfirm,
    handleTryAgain,
  } = useAssessmentPage();

  const renderLoading = () => (
    <Box
      sx={{
        width: '100%',
        height: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <CircularProgress color='primary' size='32px' />
      <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>
        Loading
      </Typography>
    </Box>
  );

  const renderSuccess = () => (
    <Box
      sx={{
        width: '100%',
        height: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <CheckCircleIcon
        sx={{ fontSize: '3.5rem', color: theme.palette.success.main }}
      />
      <Box
        sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
      >
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>
          Thank you
        </Typography>
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 400,
            color: theme.palette.semiBlack.main,
          }}
        >
          We saved your assessment
        </Typography>
      </Box>
    </Box>
  );

  const renderError = () => (
    <Box
      sx={{
        width: '100%',
        height: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <WarningIcon
        sx={{ fontSize: '3.5rem', color: theme.palette.error.main }}
      />
      <Box
        sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
      >
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>
          Server error
        </Typography>
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 400,
            color: theme.palette.semiBlack.main,
          }}
        >
          We could not load the assessment. Try again later
        </Typography>
      </Box>
      <Button
        variant='outlined'
        color='primary'
        sx={{ p: '6px 16px' }}
        onClick={handleTryAgain}
      >
        TRY AGAIN
      </Button>
    </Box>
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'auto',
        bgcolor: 'F5F5F5',
      }}
    >
      <AppBar
        position='sticky'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'white',
          paddingInline: '1.5rem',
          paddingBlock: '0.75rem',
          boxShadow: 'none',
          borderBottom: theme => `1px solid ${theme.palette.grey[300]}`,
          height: '5rem',
          zIndex: 3,
        }}
      >
        <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <img src={logo} height='35rem' />
        </Box>
      </AppBar>

      {loading
        ? renderLoading()
        : isConfirmed
          ? renderSuccess()
          : !assessment && renderError()}

      <Box
        sx={{
          display: !loading && !isConfirmed ? 'flex' : 'none',
        }}
      >
        {assessment && (
          <Assessment
            assessment_id={assessment_id}
            assessment={assessment}
            token={token ?? ''}
            handleConfirm={handleConfirm}
          />
        )}
      </Box>
    </Box>
  );
};
